import type { User } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';
import type { RadarProfile } from '../types/app';

/**
 * Compatibilidade fiel com o Radar SAEB em produção (v15.9.10).
 *
 * Regra histórica do sistema:
 * - se o valor digitado já contém "@", ele é usado como e-mail exatamente como informado;
 * - caso contrário, o login vira <usuario>@radarsaeb.local.
 *
 * Não consulta/reescreve usuários e não altera senhas no Supabase.
 */
export function resolveRadarAuthEmail(value: string) {
  const login = value.trim();
  if (!login) throw new Error('Informe o usuário.');
  return login.includes('@') ? login : `${login.toLowerCase()}@radarsaeb.local`;
}

export async function signInRadar(username: string, password: string) {
  if (!supabase) throw new Error('Supabase não configurado.');
  const email = resolveRadarAuthEmail(username);
  return supabase.auth.signInWithPassword({ email, password });
}

export async function signOutRadar() {
  if (!supabase) return;
  await supabase.auth.signOut();
}

export async function loadProfile(user: User): Promise<RadarProfile> {
  if (!supabase) throw new Error('Supabase não configurado.');
  const { data, error } = await supabase
    .from('profiles')
    .select('id,name,username,role,school_id,active,must_change_password')
    .eq('id', user.id)
    .single();

  if (error) throw error;
  if (!data) throw new Error('Perfil do usuário não localizado.');
  if (!data.active) throw new Error('Este usuário está inativo no Radar SAEB.');
  return data as RadarProfile;
}
